module.exports = __webpack_public_path__ + "img/banner_bg.c589f21d.jpg";